module.exports = __webpack_public_path__ + "static/media/01-galeria-04-suarez-mobile@2x.418a4437.jpg";